import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ValueProposition } from "./components/ValueProposition";
import { ProductsSection } from "./components/ProductsSection";
import { HowItWorks } from "./components/HowItWorks";
import { FeaturesSection } from "./components/FeaturesSection";
import { AppStores } from "./components/AppStores";
import { CTASection } from "./components/CTASection";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import { LoginPage } from "./components/LoginPage";
import { AdminPage } from "./components/AdminPage";
import { SettingsPage } from "./components/SettingsPage";
import { SEO } from "./components/SEO";

// Landing Page Component
const LandingPage = () => (
  <div className="min-h-screen bg-background text-foreground theme-transition" data-testid="app-container">
    <SEO />
    <Header />
    <main>
      <HeroSection />
      <ValueProposition />
      <ProductsSection />
      <HowItWorks />
      <FeaturesSection />
      <AppStores />
      <CTASection />
      <ContactForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/settings" element={<SettingsPage />} />
            </Routes>
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
